/* eslint-disable max-len */
import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { ModalNext, ModalHeader, ModalBody, ModalFooter, useModal } from '@jutro/components';
import { ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';

import { useValidation } from '@xengage/gw-portals-validation-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
// eslint-disable-next-line import/no-unresolved
import config from 'app-config';
import { useTranslator } from '@jutro/locale';
import { platformMessages } from 'ml-components-platform-react';
import { MLVehicleInfoLookupService } from 'ml-services-common-react';
import { MLDriverVehicleUtil } from 'ml-portals-util-react';
import { MLAlertGroupComponent } from 'ml-components-common-react';
import messages from './PUPAddVehiclePopupComponent.messages';
import qnbStyles from './PUPAddVehiclePopupComponent.module.scss';
import metadata from './PUPAddVehiclePopupComponent.metadata.json5';
import agentStyles from './PUPAddVehiclePopupComponent-agent.module.scss';
import agentMetadata from './PUPAddVehiclePopupComponent-agent.metadata.json5';
import SelectVehiclePopupComponent from './PUPSelectVehiclePopupComponent';
import { Button } from '@jutro/legacy/components';


import { ScrollToError } from '@jutro/legacy/wizard-next';


function PUPAddVehiclePopupComponent(props) {
    const modalApi = useModal();
    const {
        viewModel,
        viewModelService,
        isOpen,
        onResolve,
        onReject,
        // callback function to perform additional actions like validation, etc.
        onSaveAction,
        submissionVM,
        quoteID,
        getUnderlyingPolicies,
        isEdit,
        checkForDuplicateVin,
        checkforNonOwnedPolicy,
        onAddPolicy,
        isGPA,
        isUMB_NP,
        showProgressDialog,
        hideProgressDialog,
        isCompRaterQuote
    } = props;

    const styles = isGPA ? agentStyles : qnbStyles;

    const bodyTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('BodyType');
    const { authHeader } = useAuthentication();
    const { refreshData } = useDataRefresh();

    const [getViewModel, updateViewModel] = useState(viewModel);
    const [showValidtionErrors, setShowValidtionErrors] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const { isComponentValid, onValidate } = useValidation('PUPAddVehiclePopupModel');
    const vehicleVM = getViewModel;

    const isOfVehicleType = (category) => {
        return _.get(vehicleVM, "type.value.code", "") === category;
    };
    const isPrivatePassenger = isOfVehicleType('private_passenger_autos_ml');
    const isMotorcycle = isOfVehicleType('Motorcycle');
    const isMoped = isOfVehicleType('Moped');
    const isMotorHome = isOfVehicleType('MotorHome');
    // const isRecreational = isOfVehicleType('Recreational');
    const isOther = isOfVehicleType('Other');
    // const isFurnished = isOfVehicleType('Furnished');
    const isLowSpeedVehicle = isOfVehicleType('LowSpeed_ML');
    const isGolfCart = isOfVehicleType('GolfCart_ML');
    const isATVSnowmobile = isOfVehicleType('atv_snowmobile_ml');
    const isCollectible = isOfVehicleType('collectible_ml');
    const isLightTruck = isOfVehicleType('pickups_ml');
    const isVanSuv = isOfVehicleType('vans_suvs_ml');
    const isPanelTruck = isOfVehicleType('panel_trucks_ml');
    const isFlatbedTruck = isOfVehicleType('flat_bed_box_truck_ml');
    const isOtherPersonallyRegistered = isOfVehicleType('Other_Personally_Registered');
    const policyState = _.get(submissionVM, 'baseData.policyAddress.state.value.code');

    const [showVINRow, setVINRow] = useState(false);
    const [makes, updatePossibleMakes] = useState([]);
    const [models, updatePossibleModels] = useState([]);
    const [trims, updatetrims] = useState([]);
    const [validVIN, setValidVIN] = useState(false);
    const [isUnlistedModel, setIsUnlistedModel] = useState(false);
    const [readOnly, setReadOnly] = useState(false);
    const [trimNotFound, setTrimNotFound] = useState(false);
    const [validBodyTypes, setValidBodyTypes] = useState([]);
    const [types, setTypes] = useState([]);
    const [hasDuplicateVins, setDuplicateVins] = useState(false);
    const [verifyVinClick, setVerifyVinClick] = useState(false);
    const [oldVin, setOldVin] = useState(null);
    const [vinCleared, setVinCleared] = useState(false);
    const [savedVinPrefixes, setVinPrefixes] = useState([]);
    const [isVinSelectedByUser, setIsVinSelectedByUser] = useState(false);
    const [alerts, setAlerts] = useState([]);
    const [didMotorcycleUpdate, setDidMotorcycleUpdate] = useState(false);
    const [priorVinInput, setPriorVinInput] = useState(null);

    const translator = useTranslator();

    const initializeTypeOptions = () => {
        let typeList;
        if(policyState !== 'NH'){
            typeList = vehicleVM.type.aspects.availableValues
                .filter((type) => type.code !== 'Other_Personally_Registered');
        }else{
            typeList = vehicleVM.type.aspects.availableValues;
        }
        setTypes(typeList.map((type) => {
            return {
                code: type.code,
                name: translator({id:type.name})
            }
        }));
    };

    const {
        mapVinResponseToVehicle,
        hasErrorCodes,
        hasCompCollSymbolsNoYear,
        clearPupVinFields,
        getErrorDescription
    } = MLDriverVehicleUtil(viewModelService);

    const getTypeKeyDescription = useCallback((typeKeyName) => {
        return translator({
            id: typeKeyName,
            defaultMessage: typeKeyName
        });
    }, [translator]);

    const writeValue = (value, path) => {
        const newViewModel = viewModelService.clone(getViewModel);
        _.set(newViewModel, path, value);
        updateViewModel(newViewModel);
    };

    const checkForVinOrSerialNumber = () => {        
        const serialNum = _.get(getViewModel ,'serialNumber.value');
        const vin = _.get(getViewModel ,'vin.value');

        if (! (vin > '' || serialNum > '')) {
            return false;
        }

        return true;
    };

    const handleSave = useCallback(
        () => {
            const ulPolicyFixID = _.get(getViewModel, 'ulPolicyFixID.value');
            if (ulPolicyFixID && checkforNonOwnedPolicy(ulPolicyFixID)) {
                const errorMessage = translator(messages.nonOwnerPolicyError);
                const newAlerts = [...alerts];
                newAlerts.push({type: 'error', message: errorMessage, block: 'nonOwnerPolicyError'});
                setAlerts(newAlerts);
                return;
            }
            if (!isComponentValid) {
                setShowValidtionErrors(true);
                setErrorTimestamp(errorTimestamp+1);
                return;
            }
            const vin = _.get(getViewModel, 'vin.value')
            if(vin && checkForDuplicateVin(vin)){
                setDuplicateVins(true);
                return;
            }

            // If type is other, VIN Or Serial Number is required and back-end validations were not working for this
            const type = _.get(getViewModel ,'type.value.code')
            if (type === 'Other' && !checkForVinOrSerialNumber()) {
                const errorMessage = translator(messages.vinOrSerialNumberRequired);
                const newAlerts = [...alerts];
                newAlerts.push({type: 'error', message: errorMessage, block: 'nonOwnerPolicyError'});
                setAlerts(newAlerts);
                document.getElementById("errorContainer").scrollIntoView({ behavior: 'smooth'})

                return;
            }

            if (onSaveAction && !onSaveAction(getViewModel)) {
                return;
            }
            onResolve(getViewModel);
        },
        [getViewModel, checkforNonOwnedPolicy, isComponentValid, checkForDuplicateVin, onSaveAction, onResolve, translator, alerts, errorTimestamp]
    );

    const handleClose = useCallback(() => {
        setAlerts([]);
        onReject();
    }, [onReject]);

    const setCarYears = () => {
        const currentYear = new Date().getUTCFullYear();
        const { oldestCarYear } = config.personalAutoConfig;
        // _.range is not inclusive. Need to add -1 to get correct years
        const yearRange = _.range(currentYear + 1, oldestCarYear - 1);
        const years = yearRange.map(_.toString).map((year) => ({
            code: year,
            name: year
        }));
        return years;
    };

    const hasVin = () => {
        return !!vehicleVM.vin.value;
    }

    const isVehicleYearPre1981 = useCallback(() => vehicleVM.value.year && vehicleVM.value.year < 1981, [vehicleVM]);

    const showSerial = () => isLowSpeedVehicle || isGolfCart || isOther || isOtherPersonallyRegistered && !_.get(vehicleVM, 'vin.value');

    const isPrivatePassengerVanOrTruck = () => isPrivatePassenger || isVanSuv || isLightTruck;

    const isVinVerifiableVehicle = () => isPrivatePassengerVanOrTruck() || isCollectible || isOther || isPanelTruck || isFlatbedTruck;

    const isVinValidationRequired = () => isVinVerifiableVehicle() && vehicleVM.year.value && vehicleVM.year.value > 1981;

    const isLowSpeedVehicleGolfCartOrPersonal = () => isLowSpeedVehicle || isGolfCart || isOtherPersonallyRegistered;

    const isLowSpeedOrGolfCart = () => isLowSpeedVehicle || isGolfCart;

    const isLowSpeedVehicleGolfCartATVSnowOrMotorHome = () => isLowSpeedVehicle || isGolfCart || isMotorHome || isATVSnowmobile;

    const isMotorcycleOrMoped = () => isMotorcycle || isMoped;

    const showDropdownYear = () => !isLowSpeedVehicleGolfCartATVSnowOrMotorHome() && !isUnlistedModel && !readOnly && !isOtherPersonallyRegistered;

    const showDropdownMake = () => (!isLowSpeedVehicleGolfCartATVSnowOrMotorHome() && !isMotorcycleOrMoped()) && !isUnlistedModel &&
    !readOnly && !isOtherPersonallyRegistered && !isVehicleYearPre1981();

    const showDropdownModel = () => (!isLowSpeedVehicleGolfCartATVSnowOrMotorHome() && !isMotorcycleOrMoped()) && !isUnlistedModel && 
            !readOnly && ((makes && makes.length > 0) || 
            _.isUndefined(vehicleVM.year.value)) && !isOtherPersonallyRegistered;

    const showBodyType = () => {
        if(isGPA){
            return isPrivatePassengerVanOrTruck() || isCollectible || isPanelTruck || isFlatbedTruck;
        }
        return isPrivatePassengerVanOrTruck() || isCollectible || isPanelTruck || isFlatbedTruck || !vehicleVM.type.value;
    }

    const showTrim = () => !isLowSpeedVehicleGolfCartATVSnowOrMotorHome() && !isOtherPersonallyRegistered && !isMotorcycle && !isMoped;

    const showCCS = () => isMotorcycle || isMoped || isATVSnowmobile || isOther;

    const showUnlistedModel = () => (isPrivatePassenger || isCollectible || isLightTruck || isVanSuv || isPanelTruck || isFlatbedTruck) && !isVehicleYearPre1981();

    const showLookupButton = () => (isPrivatePassenger || isCollectible || isLightTruck || isVanSuv || isPanelTruck || isFlatbedTruck) && !validVIN && !(vehicleVM.year.value && vehicleVM.year.value < 1981) && !vehicleVM.serialNumber.value;

    const showVerifyVin = () => {
        return vehicleVM.type && isPrivatePassenger || isCollectible || isLightTruck || isVanSuv || isPanelTruck || isFlatbedTruck;
    };

    const isFreeTextTrimFieldVisible = () => {
        if (isUnlistedModel || readOnly) {
            return true;
        }

        if (isGPA) {
            if (!vehicleVM.year.value || !vehicleVM.model.value && !isVehicleYearPre1981()) {
                return false;
            }
        }

        if (isLowSpeedOrGolfCart() || isOtherPersonallyRegistered) {
            return false;
        }

        if (isVehicleYearPre1981()) {
            return true;
        }

        if (isGPA) {
            return trims.length === 0 || vehicleVM.value.isVinValidated;
        }

        return trims.length === 0 || (trims.length > 0 && readOnly);
    };

    const isTrimOptionsFieldVisible = () => {
        if (isLowSpeedOrGolfCart() || isOtherPersonallyRegistered) {
            return false;
        }

        if (isUnlistedModel || readOnly) {
            return false;
        }

        if (isVehicleYearPre1981()) {
            return false;
        }

        if (isGPA) {
            return !readOnly && !vehicleVM.value.isVinValidated;
        }

        return trims.length > 0 && !readOnly;
    };

    const clearVehicleFields = useCallback(() => {
        vehicleVM.year = undefined;
        vehicleVM.make = undefined;
        vehicleVM.makeCode = undefined;
        vehicleVM.model = undefined;
        vehicleVM.modelCode = undefined;
        vehicleVM.bodyType = undefined;
        vehicleVM.trim_ML = undefined;
        vehicleVM.vin = undefined;

        vehicleVM.value.isVinValid = false;
        setReadOnly(false);
    // eslint-disable-next-line max-len
    }, [vehicleVM]);

    const updateVin = useCallback((value) => {
        setReadOnly(false);
        setValidVIN(false);
        clearPupVinFields(vehicleVM);
        const newViewModel = viewModelService.clone(getViewModel);
        updateViewModel(newViewModel);
    }, [clearPupVinFields, vehicleVM]);

    const onFocusVinNumber = useCallback(() => {
        setPriorVinInput(vehicleVM.vin.value);
    }, [vehicleVM.vin.value]);

    const onBlurVinNumber = useCallback(() => {
        const newValue = vehicleVM.vin.value;
        if (newValue !== priorVinInput && isVinValidationRequired() && !isOther) {
            updateVin(newValue);
        }
    }, [isVinValidationRequired, priorVinInput, updateVin, vehicleVM.vin.value]);

    const lookupVIN = useCallback(async (vehicle, returnFullResults = false) => {
        const vehicleYear = vehicle.year.value ? vehicle.year.value.toString() : null;
        const req = {
            year: vehicleYear,
            makeCode: vehicle.makeCode.value,
            modelCode: vehicle.modelCode.value,
            quoteID: quoteID
        };

        if ((req.year) && (req.makeCode) && (req.modelCode)) {
            showProgressDialog(platformMessages.loadingTrims);
            const result = await MLVehicleInfoLookupService.lookupVin(req, authHeader);
            hideProgressDialog();
            if (returnFullResults) {
                return result.vinPrefixes;
            }

            const vinPrefixes = result.vinPrefixes.map((prefix) => ({
                code: prefix.vinPrefix,
                name: prefix.trim
            }));
            return vinPrefixes;
        }
        return [];
    }, [authHeader, hideProgressDialog, quoteID, showProgressDialog]);

    const getCleanVinPrefixes = (vinPrefixes) => {
        const prefixesWithTrim = vinPrefixes.filter((prefix) => !_.isEmpty(prefix.trim));
        return prefixesWithTrim;
    };

    const getTrimsFromVinPrefixes = useCallback((vinPrefixes) => {
        if(vinPrefixes){
            const cleanPrefixes = getCleanVinPrefixes(vinPrefixes);
            setVinPrefixes(cleanPrefixes);
            const auxTrims = [];
            const result = [];
            cleanPrefixes.forEach((vinPrefix) => {
                if (auxTrims.indexOf(vinPrefix.trim) === -1 && (vinPrefix.trim && vinPrefix.trim.length > 0)) {
                    if (isGPA || (!isGPA && vehicleVM.bodyType && vehicleVM.bodyType.value && vinPrefix.bodyType === vehicleVM.bodyType.value.code)) {
                        auxTrims.push(vinPrefix.trim);
                        result.push({
                            code: vinPrefix.trim,
                            name: vinPrefix.trim
                        })
                    }
                }
            });
            return result;
        }
    }, [isGPA, vehicleVM.bodyType])

    const onTypeSelect = (value, path) => {
        clearPupVinFields(vehicleVM);
        setReadOnly(false);
        _.set(vehicleVM, path, value);
        setVINRow(!((value === 'private_passenger_autos_ml' || value === 'collectible_ml' || value === 'pickups_ml') || value ==='vans_suvs_ml' && !vehicleVM.vin.value));
        setValidVIN(false);
        setVerifyVinClick(false);
        if (!showVerifyVin()) {
            vehicleVM.value.isVinValidated = true;
        }
        const newViewModel = viewModelService.clone(getViewModel);
        updateViewModel(newViewModel);
    }

    const onBodyTypeSelect = async (value, path) => {
        _.set(vehicleVM, path, value);
        _.set(vehicleVM, 'trim_ML', undefined);
        
        const vinPrefixes = await lookupVIN(vehicleVM, true);
        const trimCodes = getTrimsFromVinPrefixes(vinPrefixes);

        updatetrims(trimCodes);
        const newViewModel = viewModelService.clone(getViewModel);
        updateViewModel(newViewModel);
    }

    const fetchMakes = useCallback(async (vehicle) => {
        if (vehicle.year.value) {
            const req = {
                year: vehicle.year.value
            };
            showProgressDialog(platformMessages.loadingMakes);
            const result = await MLVehicleInfoLookupService.lookupMakes(req, authHeader);
            const makeCodes = result.makesCodes.map((make) => ({
                code: make.code,
                name: make.description
            }));
            hideProgressDialog();
            return makeCodes;
        }
        return [];
    }, [authHeader, hideProgressDialog, showProgressDialog]);


    const onYearSelect = useCallback(async (value, path, { beforeValue }) => {
        _.set(vehicleVM, path, value);
        // Enhancement RLS 2.7.14 disable logic for motorcycles
        if (isMotorcycle) {
            setDidMotorcycleUpdate(!didMotorcycleUpdate);
            return;
        }
        const makeCodes = await fetchMakes(vehicleVM);

        if (makeCodes.length > 0) {
            updatePossibleMakes(makeCodes);
        }

        if (value !== beforeValue && !validVIN && isVinValidationRequired()) {
            vehicleVM.vin.value = undefined;
            setVinCleared(true);
        }
        if(isVehicleYearPre1981()){
            setValidBodyTypes(bodyTypelist.codes.map((bType) => {
                return {
                    code: bType.code,
                    name: getTypeKeyDescription(bType.name)
                };
            }));
        }
        if(!readOnly){
            vehicleVM.make.value = undefined;
            vehicleVM.makeCode.value = undefined;
        }
    }, [bodyTypelist.codes, didMotorcycleUpdate, fetchMakes, getTypeKeyDescription, isMotorcycle, isVehicleYearPre1981, isVinValidationRequired, readOnly, validVIN, vehicleVM]);


    const fetchModels = useCallback(async (vehicle) => {
        if (vehicle.year.value && vehicle.makeCode.value) {
            const req = {
                year: vehicle.year.value,
                makeCode: vehicle.makeCode.value
            };
            showProgressDialog(platformMessages.loadingModels);
            const result = await MLVehicleInfoLookupService.lookupModels(req, authHeader);
            const modelCodes = result.models.map((model) => ({
                code: model.code,
                name: model.description
            }));
            hideProgressDialog();

            return modelCodes;
        }
        return [];
    }, [authHeader, hideProgressDialog, showProgressDialog]);

    // const getBodyTypeValue = useCallback((bodyType) => {
    //     const { name } = bodyTypelist.getCode(bodyType);
    //     return getTypeKeyDescription(name);
    // }, [bodyTypelist, getTypeKeyDescription]);

    const getMakenameByCode = useCallback((makeCode) => {
        const filtered = makes.filter((make) => make.code === makeCode);
        if (filtered.length > 0) {
            return filtered[0].name;
        }
        return null;
    }, [makes]);

    const getModelnameByCode = useCallback((modelname) => {
        const filtered = models.filter((make) => make.code === modelname);
        if (filtered.length > 0) {
            return filtered[0].name;
        }
        return null;
    }, [models]);

    const getCleanVinBodyTypes = (vinPrefixes) => {
        const prefixesWithBodyType = vinPrefixes.filter((prefix) => !_.isEmpty(prefix.bodyType));
        return prefixesWithBodyType;
    };

    const getBodyTypesFromVinPrefixes = useCallback((vinPrefixes) => {
        if (isUnlistedModel) {
            return bodyTypelist.codes.map((bType) => {
                return {
                    code: bType.code,
                    name: getTypeKeyDescription(bType.name)
                };
            });
        }
        if (vinPrefixes) {
            const cleanPrefixes = getCleanVinBodyTypes(vinPrefixes);
            setVinPrefixes(cleanPrefixes);
            const auxBodyTypes = [];
            cleanPrefixes.forEach((vinPrefix) => {
                if (auxBodyTypes.indexOf(vinPrefix.bodyType) === -1 && (vinPrefix.bodyType && vinPrefix.bodyType.length > 0)) {
                    auxBodyTypes.push(vinPrefix.bodyType);
                }
            });

            if (!isUnlistedModel) {
                return bodyTypelist.codes.filter((bType) => {
                    return auxBodyTypes.includes(bType.code);
                }).map((bType) => {
                    return {
                        code: bType.code,
                        name: getTypeKeyDescription(bType.name)
                    };
                });
            }
            return bodyTypelist.codes.map((bType) => {
                return {
                    code: bType.code,
                    name: getTypeKeyDescription(bType.name)
                };
            });

            // MLDriverVehicleUtil.setVinIntegrationErrorCode($scope.yymResponse.error, $scope.vehicle.value);
        }
    },[bodyTypelist.codes, getTypeKeyDescription, isUnlistedModel]);

    const onMakeSelect = useCallback(async (value, path, { beforeValue }) => {
        _.set(vehicleVM, path, value);
        // Enhancement RLS 2.7.14 disable logic for motorcycles
        if (isMotorcycle) {
            setDidMotorcycleUpdate(!didMotorcycleUpdate);
            return;
        }

        const modelCodes = await fetchModels(vehicleVM);
        const makeName = getMakenameByCode(value);
        _.set(vehicleVM, 'make', makeName);
        if(value !== beforeValue && !validVIN){
            vehicleVM.model.value = undefined;
            vehicleVM.modelCode.value = undefined;
            vehicleVM.vin.value = undefined;
            setVinCleared(true);
        }
        updatePossibleModels(modelCodes);
        if(_.get(vehicleVM, 'model.value')){
            const vinPrefixes = await lookupVIN(vehicleVM, true);
            const trimCodes = getTrimsFromVinPrefixes(vinPrefixes);
            updatetrims(trimCodes);
            if(!isGPA){
                const bTypes = getBodyTypesFromVinPrefixes(vinPrefixes);
                setValidBodyTypes(bTypes);
            }
        }
    },
    [didMotorcycleUpdate, fetchModels, getBodyTypesFromVinPrefixes, getMakenameByCode, getTrimsFromVinPrefixes, isGPA, isMotorcycle, lookupVIN, validVIN, vehicleVM]);

    const onModelSelect = useCallback(async (value, path, { beforeValue }) => {
        _.set(vehicleVM, path, value);
        // Enhancement RLS 2.7.14 disable logic for motorcycles
        if (isMotorcycle) {
            setDidMotorcycleUpdate(!didMotorcycleUpdate);
            return;
        }
        
        const modelName = getModelnameByCode(value);
        _.set(vehicleVM, 'model', modelName);
        const vinPrefixes = await lookupVIN(vehicleVM, true);
        const trimCodes = getTrimsFromVinPrefixes(vinPrefixes);
        
        if(!readOnly){
            vehicleVM.bodyType.value = undefined;
            vehicleVM.trim_ML.value = undefined;
            vehicleVM.vin.value = undefined;
            setVerifyVinClick(false);
        }
        updatetrims(trimCodes);
        if(!isGPA){
            const bTypes = getBodyTypesFromVinPrefixes(vinPrefixes);
            setValidBodyTypes(bTypes);
        }
        if (value !== beforeValue && !validVIN) {
            vehicleVM.vin.value = undefined;
            setVinCleared(true);
        }
    },
    [didMotorcycleUpdate, getBodyTypesFromVinPrefixes, getModelnameByCode, getTrimsFromVinPrefixes, isGPA, isMotorcycle, lookupVIN, readOnly, validVIN, vehicleVM]);

    const onModelCheckBoxSelect = useCallback(async (value) => {
        setIsUnlistedModel(value);
        if(value === true){
            setReadOnly(false);
            setValidBodyTypes([]);
        }
    }, []);

    const handleLookupVinError = (vehicleInfo) => {
        const errorMessage = (!_.isEmpty(vehicleInfo.error) && !_.isEmpty(vehicleInfo.error.code) && vehicleInfo.error.code === 'N')
        ? getErrorDescription(vehicleInfo) : `${`VIN  ${vehicleVM.vin.value}`}${translator(messages.vinResponseInValid)}`;

        const newAlerts = [...alerts];
        newAlerts.push({type: 'error', message: errorMessage, block: 'invalidVin'});
        setAlerts([...newAlerts.filter((alert) => alert.block !== "invalidVin"), {
            type: "error",
            message: errorMessage,
            block: "invalidVin"
        }]);
    };

    const verifyVIN = useCallback(async () => {
        setDuplicateVins(false);
        if (vehicleVM.vin.value && vehicleVM.vin.value.length > 0) {
            const req = {
                vin: vehicleVM.vin.value,
                quoteID: quoteID,
                isCompRaterQuote: isCompRaterQuote
            };
            let vehicleInfo;
            try{
                vehicleInfo = await MLVehicleInfoLookupService.verifyVin(req, authHeader);
            }catch(e){
                console.error(e);
            }
            setVerifyVinClick(true);
            // eslint-disable-next-line max-len
            if (vehicleInfo && hasCompCollSymbolsNoYear(vehicleInfo) && !hasErrorCodes(vehicleInfo)) {
                setValidVIN(true);
                const errorMessage = translator(messages.vinResponseEnterYear);
                const newAlerts = [...alerts];
                newAlerts.push({type: 'error', message: errorMessage, block: 'invalidVin'});
                setAlerts(newAlerts);
                setShowValidtionErrors(true);
                setErrorTimestamp(errorTimestamp+1);
                mapVinResponseToVehicle(vehicleInfo, vehicleVM.value);
                vehicleVM.value.isVinValidated = true;
            }
            // eslint-disable-next-line max-len
            if (vehicleInfo && vehicleInfo.make && vehicleInfo.model && vehicleInfo.year && !hasErrorCodes(vehicleInfo)) {
                setValidVIN(true);
                mapVinResponseToVehicle(vehicleInfo, vehicleVM.value);
                vehicleVM.value.isVinValidated = true;
                setValidBodyTypes(bodyTypelist.codes.map((bType) => {
                    return {
                        code: bType.code,
                        name: getTypeKeyDescription(bType.name)
                    };
                }));
                setReadOnly(true);
                if (!vehicleInfo.trim) {
                    setTrimNotFound(true);
                } else {
                    setTrimNotFound(false);
                }
            } else {
                setValidVIN(false);
                setReadOnly(false);
                handleLookupVinError(vehicleInfo);
                setShowValidtionErrors(true);
                setErrorTimestamp(errorTimestamp+1);
                setTrimNotFound(false);
            }
        }else{
            setReadOnly(false);
            setTrimNotFound(false);
        }
    // eslint-disable-next-line max-len
    }, [vehicleVM.vin.value, vehicleVM.value, quoteID, isCompRaterQuote, hasCompCollSymbolsNoYear, hasErrorCodes, authHeader, translator, alerts, errorTimestamp, mapVinResponseToVehicle, bodyTypelist.codes, getTypeKeyDescription]);

    const onVINChange = (value, path) => {
        _.set(vehicleVM, path, value);
        setValidVIN(false);
        setDuplicateVins(false);
        setVerifyVinClick(false);
        refreshData();
        if (value) {
            setVinCleared(false);
        }
    }

    const onPolicyInfoChange = (value, path) => {
        _.set(vehicleVM, path, value);
        refreshData();
        if(value === 'new'){
            onAddPolicy().then((model) => {
                let val;
                if(model){
                    val = model.ulPolicyFixID.value;
                }
                const newViewModel = viewModelService.clone(getViewModel);
                _.set(newViewModel, path, val);
                updateViewModel(newViewModel);
            })
        }
    };

    const validateSerialNumberWithVin = (value, path, {beforeValue}) => {
        _.set(vehicleVM, path, value);

        if (!value) {
            refreshData();
            return;
        }
        value = value ? value.toUpperCase() : undefined;
        if (value !== beforeValue && vehicleVM.type.value.code === 'Other' && vehicleVM.vin) {
            vehicleVM.vin.value = undefined;
        }
        refreshData();
    };

    const getVinLabel = () => {
        if(showLookupButton()){
            return messages.OrSimplyEnterVin;
        }
        return messages.vin;
    }

    const getVinHelpLabel = () => {
        return isATVSnowmobile || isMotorcycle || isOther ?  messages.findSerialNumber : messages.findVin
    }

    const getVinHelpMessage = () => {
        return (isATVSnowmobile || isMotorcycle || isOther) ? messages.SerialNumberTooltip : messages.vinHelpTextMessage;
    }

    const getVehicleTypeTooltipContent = () => {
        return policyState === 'NH' ? messages.vehicleTypeTooltipContentNH : messages.vehicleTypeTooltipContent;
    }

    const isPartialVinValid = () => {
        return vehicleVM.year && vehicleVM.value.make && vehicleVM.modelCode && vehicleVM.value.bodyType && vehicleVM.value.trim_ML;
    }

    const vinValid = () => {
        return validVIN && verifyVinClick;
    }


    const shouldClearFields = (vehicle) => {
        const vinPrefixes = savedVinPrefixes.filter((vinPrefix) => vinPrefix.trim === vehicle.trim_ML.value);
        const prefixesMatchedWithVin = vinPrefixes.filter((prefix) => prefix.vinPrefix === vehicle.vin.value);
        return prefixesMatchedWithVin.length === 0;
    };

    const validateVinWithSerialNumber = (vehicle) => {
        vehicle.vin.value = vehicle.vin.value ? vehicle.vin.value.toUpperCase() : null;
        if (vehicle.vin.value !== oldVin && shouldClearFields(vehicle) && !vinCleared) {
            clearPupVinFields(vehicle);
            setValidVIN(false)
        }
        if (!!(vehicle.type.value) && vehicle.type.value.code === 'Other' && vehicle.serialNumber && vehicle.vin.value) {
            vehicle.serialNumber.value = null;
        }
        setReadOnly(false);
        setVerifyVinClick(false);
    };

    const hasYear = () => {
        return !!vehicleVM.year.value;
    };

    const selectVinPrefix = (selectedVin) => {
        if (vehicleVM.vintellFields_ML) { 
            vehicleVM.vintellFields_ML.value = selectedVin;
        }
        vehicleVM.bodyType.value = selectedVin.bodyType;
        vehicleVM.trim_ML.value = selectedVin.trim;
        if (selectedVin.trim) {
            setTrimNotFound(false);
        } else {
            setTrimNotFound(true);
        }
        vehicleVM.vin.value = selectedVin.vinPrefix;
        vehicleVM.value.isVinValidated = true;
        setIsVinSelectedByUser(true);
        const newVM = viewModelService.clone(getViewModel);
        updateViewModel(newVM);
    }

    const openSelectVehiclePopup = (vins) => {
        modalApi.showModal(
            <SelectVehiclePopupComponent vins={vins} />
        ).then((selectedVin) => {
            selectVinPrefix(selectedVin);
        });
    }

    const lookUpVinButton = async () => {
        const vinPrefixes = await lookupVIN(vehicleVM, true);
        
        if (vinPrefixes.length > 0) {
            vinPrefixes.forEach((vinVehicle) =>{
                vinVehicle.checked = false;
            });
            const vins = getCleanVinPrefixes(vinPrefixes);
            openSelectVehiclePopup(vins);
        } else {
            // $scope.error = $filter('translate')('ml.edge.common.directives.templates.ml-partial-vehicle-details.Vin Lookup Error Message');
        }
    }

    const getStatesList = () => {
        const states = vehicleVM?.licenseState?.aspects?.availableValues || [];

        return states
            .filter((state) => state.code !== 'ALL')
            .map((state) => ({
                ...state,
                name: translator({
                    id: state.name,
                    defaultMessage: state.name
                })
            }));
    };

    const overrideProps = {
        alertComponent: {
            customAlerts: alerts,
            isPOPUP: true
        },
        '@field':{
            disabled: readOnly
        },
        vehicletype: {
            availableValues: types,
            onValueChange: onTypeSelect,
            disabled: false
        },
        vehicletypeTooltip: {
            tooltipContent: getVehicleTypeTooltipContent()
        },
        describeOtherContainer: {
            visible: isOther
        },
        yearDropdown: {
            availableValues: setCarYears(),
            onValueChange: onYearSelect,
            visible: showDropdownYear(),
        },
        yearText: {
            visible: !showDropdownYear(),
        },
        makeDropdown: {
            availableValues: makes,
            visible: showDropdownMake(),
            onValueChange: onMakeSelect,
        },
        makeText: {
            visible: !showDropdownMake(),
        },
        vehicleModelTypelist: {
            availableValues: models,
            visible: showDropdownModel(),
            onValueChange: onModelSelect,
        },
        vehicleModelText: {
            visible: !showDropdownModel()
        },
        myModelListedCheck: {
            onValueChange: onModelCheckBoxSelect,
            value: isUnlistedModel,
            visible: showUnlistedModel()
        },
        bodyTypeDropdown: {
            availableValues: validBodyTypes.length > 0 ? validBodyTypes : bodyTypelist.codes.map((bType) => {
                return {
                    code: bType.code,
                    name: getTypeKeyDescription(bType.name)
                };
            }),
            disabled: readOnly && vehicleVM.trim_ML.value !== undefined,
            onValueChange: onBodyTypeSelect,
            visible: showBodyType()
        },
        trimContainer: {
            visible: showTrim()
        },
        trimDropdown: {
            availableValues: trims,
            visible: isTrimOptionsFieldVisible(),
            disabled:  readOnly
        },
        trimText: {
            visible: isFreeTextTrimFieldVisible(),
            disabled: readOnly && !trimNotFound
        },
        licenseState: {
            disabled: false
        },
        serialNumberContainer: {
            visible: showSerial()
        },
        serialNumber: {
            disabled: vehicleVM.vin && vehicleVM.vin.value !== undefined,
            onValueChange: validateSerialNumberWithVin
        },
        ccsRowContainer: {
            visible: showCCS()
        },
        ccs: {
            disabled: false
        },
        horsepowerRowContainer: {
            visible: isOther
        },
        horsepower: {
            disabled: false
        },
        excludeVehicle: {
            disabled: false
        },
        policyInfo: {
            availableValues: getUnderlyingPolicies(),
            onValueChange: onPolicyInfoChange,
            disabled: false
        },
        vinContainer: {
            visible: !showSerial() || isOther
        },
        vinTextRow: {
            visible: !showVINRow
        },
        addMyVin: {
            onClick: () => {
                setVINRow(true);
            },
            visible: !showVINRow,
            className: "addVINButton vehicleCtrow"
        },
        vinrow: {
            visible: showVINRow
        },
        vinNumber: {
            label: translator(getVinLabel()),
            onValueChange: onVINChange,
            disabled: false
        },
        lookUpVinButton: {
            onClick: () => verifyVIN(),
            visible: showLookupButton()
        },
        verifyVinGreenCheck: {
            visible: vinValid()
        },
        cancelVINButton: {
            onClick: () => {
                clearVehicleFields();
                setVINRow(false);
                setValidVIN(false);
            },
            visible: validVIN
        },
        vinHelpText: {
            tooltipLabel: translator(getVinHelpLabel()),
            tooltipContent: translator(getVinHelpMessage())
        }
    };

    const agentOverrideProps = {
        alertComponent: {
            customAlerts: alerts
        },
        verifyVinGreenCheck:{
            visible: vinValid()
        },
        invalidVinError:{
            visible: !validVIN && verifyVinClick
        },
        duplicatedVinError:{
            visible: hasDuplicateVins
        },
        vinrowNoLSV: {
            visible: viewModel.type && !isLowSpeedVehicleGolfCartOrPersonal()
        },
        vinNumberNoLSV: {
            onValueChange: (value, path) => {
                const newViewModel = viewModelService.clone(getViewModel);
                _.set(newViewModel, path, value);
                updateViewModel(newViewModel);
                validateVinWithSerialNumber(newViewModel);
            },
            onFocus: onFocusVinNumber,
            onBlur: onBlurVinNumber
        },
        verifyVinButton: {
            visible: showVerifyVin(),
            onClick: () => verifyVIN()
        },
        serialNumberLSVContainer: {
            visible: isLowSpeedVehicleGolfCartOrPersonal() || isOther
        },
        serialNumberLSV: {
            onValueChange: validateSerialNumberWithVin
        },
        vinOrSerialSnowmobileContainer: {
            visible: isATVSnowmobile
        },
        vehicletype: {
            availableValues: types,
            onValueChange: onTypeSelect,
            disabled: false,
            tooltip: {
                title: translator(messages.vehicleTypeTooltipHeader),
                text: translator(getVehicleTypeTooltipContent(), {
                    p: (chunks) => <p>{chunks}</p>
                }),
                placement: "bottom",
            }
        },
        describeOtherContainer: {
            visible: isOther
        },
        yearDropdown: {
            availableValues: setCarYears(),
            onValueChange: onYearSelect,
            visible: showDropdownYear(),
            disabled: readOnly
        },
        yearText: {
            visible: !showDropdownYear(),
            disabled: readOnly
        },
        makeDropdown: {
            availableValues: makes,
            visible: showDropdownMake(),
            onValueChange: onMakeSelect,
            disabled: readOnly
        },
        makeText: {
            visible: !showDropdownMake(),
            disabled: readOnly
        },
        vehicleModelTypelist: {
            availableValues: models,
            visible: showDropdownModel(),
            onValueChange: onModelSelect,
            disabled: readOnly
        },
        vehicleModelText: {
            visible: !showDropdownModel(),
            disabled: readOnly
        },
        myModelListedCheck: {
            onValueChange: onModelCheckBoxSelect,
            value: isUnlistedModel,
            visible: showUnlistedModel()
        },
        lookUpVinButtonContainer: {
            visible: (isPrivatePassenger || isCollectible || isLightTruck || isVanSuv || isPanelTruck || isFlatbedTruck) && !vinValid() && !(vehicleVM.year.value && vehicleVM.year.value < 1981) && !isUnlistedModel
        },
        lookUpVinButton: {
            onClick: () => lookUpVinButton()
        },
        lookUpVinButtonGreenCheck: {
            visible: !!((isPrivatePassenger || isCollectible || isLightTruck || isVanSuv || isPanelTruck || isFlatbedTruck) && isPartialVinValid())
        },
        lookUpVinButtonRequiredTextContainer: {
            visible: !!((isPrivatePassenger || isCollectible || isLightTruck || isVanSuv || isPanelTruck || isFlatbedTruck) && !isPartialVinValid() && !hasVin() && hasYear())
        },
        bodyTypeTrimContainer: {
            visible: !!((isPartialVinValid() && hasVin()) || isUnlistedModel || verifyVinClick || isVehicleYearPre1981())
        },
        bodyTypeDropdown: {
            availableValues: validBodyTypes.length > 0 ? validBodyTypes : bodyTypelist.codes.map((bType) => {
                return {
                    code: bType.code,
                    name: getTypeKeyDescription(bType.name)
                };
            }),
            disabled: true,
            onValueChange: onBodyTypeSelect,
            visible: !!((showBodyType() && !isVehicleYearPre1981()) && !isUnlistedModel && !readOnly && !viewModel.value.isVinValidated)
        },
        bodyTypeDropdown2: {
            availableValues: validBodyTypes.length > 0 ? validBodyTypes : bodyTypelist.codes.map((bType) => {
                return {
                    code: bType.code,
                    name: getTypeKeyDescription(bType.name)
                };
            }),
            disabled: !!(readOnly || (!isVehicleYearPre1981() && viewModel.value.isVinValidated && !isUnlistedModel)),
            onValueChange: onBodyTypeSelect,
            visible: !!((showBodyType() && isVehicleYearPre1981()) || isUnlistedModel || readOnly || viewModel.value.isVinValidated)
        },
        trimDropdown: {
            availableValues: trims,
            visible: isTrimOptionsFieldVisible(),
            disabled: viewModel.trim_ML.value && viewModel.trim_ML.value.length > 0
        },
        trimText: {
            visible: isFreeTextTrimFieldVisible(),
            disabled: (readOnly && !trimNotFound) && (!!vehicleVM.value.isVinValidated && !isUnlistedModel)
        },
        licenseState: {
            disabled: false
        },
        ccsRowContainer: {
            visible: showCCS()
        },
        ccs: {
            disabled: false
        },
        licensedForRoad : {
            visible: isUMB_NP,
            readOnly:(isUMB_NP && vehicleVM.value.fromPrefill_ML)
        },
        vehicleCostNew: {
            required: isUMB_NP && (isPrivatePassenger || isVanSuv || isLightTruck || isPanelTruck || isFlatbedTruck || isCollectible || isMotorHome),
            visible: isUMB_NP && (isPrivatePassenger || isVanSuv || isLightTruck || isPanelTruck || isFlatbedTruck || isCollectible || isMotorHome),
            readOnly:(isUMB_NP && vehicleVM.value.fromPrefill_ML) || (isUMB_NP && vinValid())
        },
        horsepowerRowContainer: {
            visible: isOther && !isUMB_NP
        },
        horsepower: {
            disabled: false
        },
        licenseState: {
            availableValues: getStatesList()
        },
        horsepowerNP: {
            visible: isUMB_NP,
            readOnly:(isUMB_NP && vehicleVM.value.fromPrefill_ML) || (isUMB_NP && vinValid())
        },
        excludeVehicle: {
            disabled: false,
            visible: !(vehicleVM.value.fromPrefill_ML && isUMB_NP)
        },
        policyInfo: {
            availableValues: getUnderlyingPolicies(),
            onValueChange: onPolicyInfoChange,
            disabled: false
        },
    };

    if(hasDuplicateVins){
        overrideProps.vinNumber.showErrors = true;
        overrideProps.vinNumber.validationMessages = [];
        overrideProps.vinNumber.validationMessages.push(translator(messages.duplicatedVins));
    }

    const resolvers = {
        resolveComponentMap: {
            MLAlertGroupComponent
        },
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onValidate: onValidate,
            onVerifyVIN: verifyVIN
        }
    };

    const getModalTitle = () => {
        if(isGPA){
            if(isEdit){
                return translator(messages.editVehicleExposureTitle);
            }
            return translator(messages.addVehicleExposureTitle);
        }
        if(isEdit){
            return translator(messages.editVehicleTitle);
        }
        return translator(messages.addVehicleTitle);
    }

    const getModalSubtitle = () => {
        if(!isGPA){
            return translator(messages.subtitle)
        }
        return undefined;
    }

    const getActionButtonLabel = () => {
        if(isGPA){
            if(isEdit){
                return translator(messages.EditVehicleButton);
            }
            return translator(messages.AddVehicleButton);
        }
        return translator(messages.actionbuttonLabelContinue);
    }

    const initializeMakes = async () => {
        const year = _.get(vehicleVM, 'year.value');
        if(year){
            const makeCodes = await fetchMakes(vehicleVM);
            if(isVehicleYearPre1981()){
                setValidBodyTypes(bodyTypelist.codes.map((bType) => {
                    return {
                        code: bType.code,
                        name: getTypeKeyDescription(bType.name)
                    };
                }));
            }
            if (makeCodes.length > 0) {
                updatePossibleMakes(makeCodes);
            }
        }
    };

    const initializeModels = async () => {
        const make = _.get(vehicleVM, 'make.value');
        if(make){
            const modelCodes = await fetchModels(vehicleVM);
            updatePossibleModels(modelCodes);
        }
    };

    const initializeBodyTypeAndTrims = async () => {
        const model = _.get(vehicleVM, 'model.value');
        if(model){
            const vinPrefixes = await lookupVIN(vehicleVM, true);
            const trimCodes = getTrimsFromVinPrefixes(vinPrefixes);
            const bTypes = getBodyTypesFromVinPrefixes(vinPrefixes);
            
            updatetrims(trimCodes);
            setValidBodyTypes(bTypes);
            
            // const trim = _.get(vehicleVM, 'model.value');
        }
    }

    const verifyVinOnEdit = () => {
        if (isEdit && isVinValidationRequired() && vehicleVM?.vin?.value?.length === 17) {
            verifyVIN();
        }
    };

    const checkDisableButton = () => isVinValidationRequired() && !(vinValid() || !!((isPartialVinValid() && hasVin()))) && !isOther;

    useEffect(() => {
        initializeTypeOptions();
        initializeMakes();
        initializeModels();
        initializeBodyTypeAndTrims();
        setOldVin(_.get(viewModel, 'vin.value', null));

        verifyVinOnEdit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <ModalNext
            className={styles['ml-modal-dialog']}
            isOpen={isOpen}
            onRequestClose={handleClose}
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEsc={false}
        >
            <ModalHeader
                title={getModalTitle()}
                subtitle={getModalSubtitle()}
                onClose={handleClose}
                contentLayout={{
                    component: 'div',
                    componentProps: {
                        className: styles['modal-header']
                    }
                }}
                titleLayout={{
                    component: 'flex',
                    componentProps: {
                        direction: "column",
                        className: styles['modal-title']
                    }
                }}
            />
            <ModalBody contentLayout={{
                component: 'div',
                componentProps: {
                    className: styles['modal-body']
                }
            }}
            >
                <ViewModelForm
                    uiProps={isGPA ? agentMetadata.pageContent : metadata.pageContent}
                    model={getViewModel}
                    overrideProps={isGPA ? agentOverrideProps : overrideProps}
                    onValueChange={writeValue}
                    classNameMap={resolvers.resolveClassNameMap}
                    componentMap={resolvers.resolveComponentMap}
                    onValidationChange={onValidate}
                    callbackMap={resolvers.resolveCallbackMap}
                    showErrors={showValidtionErrors}
                />
            </ModalBody>
            <ModalFooter contentLayout={{
                component: 'flex',
                componentProps: {
                    className: styles['modal-footer']
                }
            }}
            >
                <Button id="actionButton" onClick={handleSave} type="filled" disabled={checkDisableButton()}>
                    { getActionButtonLabel() }
                </Button>
                { isGPA && 
                    <Button id="cancelActionButton" onClick={handleClose} type="outlined">
                        { translator(messages.Cancel) }
                    </Button>
                }
            </ModalFooter>
            <ScrollToError counter={errorTimestamp} />
        </ModalNext>
    );
}

PUPAddVehiclePopupComponent.propTypes = {
    viewModel: PropTypes.shape({}).isRequired,
    viewModelService: PropTypes.shape({
        clone: PropTypes.func
    }).isRequired,
    isOpen: PropTypes.bool,
    onReject: PropTypes.func,
    onResolve: PropTypes.func,
    // eslint-disable-next-line react/forbid-prop-types
    // eslint-disable-next-line react/forbid-prop-types

    onSaveAction: PropTypes.func,
    quoteID: PropTypes.string,
    submissionVM: PropTypes.shape({}).isRequired,
    getUnderlyingPolicies: PropTypes.func,
    isCompRaterQuote: PropTypes.bool
};

PUPAddVehiclePopupComponent.defaultProps = {
    isOpen: false,
    onResolve: _.noop,
    onReject: _.noop,
    onSaveAction: _.noop,
    quoteID: undefined,
    isPUP: false,
    getUnderlyingPolicies: undefined,
    isCompRaterQuote: false
};

export default PUPAddVehiclePopupComponent;